import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons/lib/icons';
import React, { FC } from 'react';
import styled from 'styled-components';

export interface SiderToggleProps {
  isCollapsed: boolean;
  onClick: () => void;
  className?: string;
}

const SiderToggleBase: FC<SiderToggleProps> = ({
  isCollapsed,
  onClick,
  className,
}) => (
  <span onClick={onClick} className={className}>
    {isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
  </span>
);

export const SiderToggle = styled(SiderToggleBase)`
  font-size: 1.3rem;
  cursor: pointer;
`;
